import { render } from "./JsonExcel.vue?vue&type=template&id=1b5f596e"
import script from "./JsonExcel.vue?vue&type=script&lang=js"
export * from "./JsonExcel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__